



















































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { RateTariff } from '@/models/rateTariff/RateTariff';

import rateTariffsService from '@/services/RateTariffsService';
import exportService from '@/services/ExportService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      loading: false,
      displayReadonlyDisclaimer: true,
      term: '',
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      rateTariffsService.getAll().then((x: RateTariff[]) => {
        this.$store.commit('rateTariffs/setRateTariffs', x);

        this.applyFilters();
        this.loading = false;
      });
    },
    applyFilters() {
      let items = this.all;

      if (this.term) {
        const q = this.term.toLowerCase();
        items = items.filter(
          (x) =>
            x.tariffDesc.toLowerCase().includes(q) ||
            x.tariffName.toLowerCase().includes(q) ||
            x.tariffType.toLowerCase().includes(q)
        );
      }

      this.$store.commit('rateTariffs/setFilteredRateTariffs', items);
      this.$store.commit('rateTariffs/setPage', items.slice(0, this.pageSize));
      this.currentPage = 1;
      this.showFilters = false;
    },
    clearFilters() {
      this.$store.commit('rateTariffs/resetFilter');
    },
    csvExport() {
      exportService.csvDownload(this.all, 'Rate Tariffs');
    },
    pageChange(newPage) {
      let page = this.filteredRateTariffs.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('rateTariffs/setPage', page);
    },
  },
  computed: {
    ...mapGetters('rateTariffs', ['all', 'page', 'filteredRateTariffs']),
    pagingLength() {
      return Math.ceil(this.filteredRateTariffs.length / this.pageSize);
    },
  },
});
